import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, createClass as _createClass } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styles from './Badge.module.scss.js';

var Badge = /*#__PURE__*/function (_PureComponent) {
  _inherits(Badge, _PureComponent);
  var _super = _createSuper(Badge);
  function Badge() {
    _classCallCheck(this, Badge);
    return _super.apply(this, arguments);
  }
  _createClass(Badge, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        className = _this$props.className,
        count = _this$props.count;
      if (count === 0) {
        return null;
      }
      var safeCount = count > 99 ? '99+' : count;
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(styles.badge, className)
      }, safeCount);
    }
  }]);
  return Badge;
}(PureComponent);
Badge.propTypes = {
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  className: PropTypes.string
};
Badge.defaultProps = {
  className: ''
};

export { Badge as default };
